import { render, staticRenderFns } from "./FamilyApplication.vue?vue&type=template&id=874e8840&"
import script from "./FamilyApplication.vue?vue&type=script&lang=js&"
export * from "./FamilyApplication.vue?vue&type=script&lang=js&"
import style0 from "./FamilyApplication.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports